module.exports = __webpack_public_path__ + "media/images/social/facebook-acb904074d28ea207d74c6d73bd396fe.png";